import moment from 'moment'
import { GET_DASHBOARD_ORDERS_DATA } from './actions'

const dashboardData = {
  ordersPriceData:{},
ordersQuantityData:{},
foodQuantityData:{}
}

export default function dashboard(state = dashboardData, action) {
  switch (action.type) {
    case GET_DASHBOARD_ORDERS_DATA:
      let sortData = {}
      action.payload.map(discount => {
        const date = [moment(discount.createdAt).format('DD/MM')]
        if (sortData[date]) {
          return (sortData = { ...sortData, [date]: [...sortData[date], discount?.totalPrice] })
        } else {
          return (sortData = { ...sortData, [date]: [discount?.totalPrice] })
        }
      })

      let sortOrderData = {}
      action.payload.map(order => {
        order.ordersItems.map(orderItem => {
          const date = [moment(order.createdAt).format('DD/MM')]
          if (sortOrderData[date]) {
            return (sortOrderData = {
              ...sortOrderData,
              [date]: sortOrderData[date]+ Number(orderItem?.qty) ,
            })
          } else {
            return (sortOrderData = { ...sortOrderData, [date]: Number(+orderItem?.qty) })
          }
        })
      })

      let sortQtyData = {}
      action.payload.map(order => {
        order.ordersItems.map(orderItem => {
          const name = orderItem.name
          if (sortQtyData[name]) {
            return (sortQtyData = {
              ...sortQtyData,
              [name]: sortQtyData[name]+ Number(orderItem?.qty) ,
            })
          } else {
            return (sortQtyData = { ...sortQtyData, [name]: Number(+orderItem?.qty) })
          }
        })
      })
      console.log("🚀 ~ file: reducers.js ~ line 37 ~ dashboard ~ sortQtyData", sortQtyData)
      

      return {
        ordersPriceData: sortData,
        ordersQuantityData: sortOrderData,
        foodQuantityData:sortQtyData
      }

    default:
      return state
  }
}
